import api from '@/api/testimonials'
import {notify} from "@/helpers/notifyHelper"

export default {
	data () {
		return {
			valid: false,
			postData: null,
		}
	},
	created() {
		if (this.id) {
			api.getById(this, this.id)
				.then(response => {
					if (response.data.length) {
						this.postData = response.data[0]
					}
				})
				.catch(err => {
					notify(self, 'error', err)
				})
		}
	},
	methods: {
		update () {
			if (this.$refs.form.validate()) {
				let data = new FormData()
				Object.keys(this.postData).map(key => {
					data.append(key, this.postData[key])
				})

				api.update(this, this.postData.id, data)
					.then(() => {
						this.$router.push({name: 'Testimonials'})
					})
			}
		}
	},
	computed: {
		id () {
			return this.$route.params.id
		}
	}
}
